
<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <br />
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between"
    >
      <div class="flex flex-wrap-reverse items-center">
        <!-- ADD NEW -->
        <div
          class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="$router.push(`/usuarios/novo`).catch((err) => {})"
        >
          <feather-icon icon="UserIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Novo</span>
        </div>
      </div>
    </div>
    <vx-card title="Usuários">
      <vs-tabs>
        <vs-tab label="Copyjui">
          <div class="tab-text">
            <vs-table
              v-model="selected"
              @selected="handleSelected"
              pagination
              :max-items="100"
              search
              :data="users"
            >
              <template slot="thead">
                <vs-th sort-key="idUser">#</vs-th>
                <vs-th sort-key="photo">Foto</vs-th>
                <vs-th sort-key="userName">Nome</vs-th>
                <vs-th sort-key="email">Email</vs-th>
                <vs-th sort-key="isActive">Ativo</vs-th>
                <vs-th sort-key="grupo">Última Interação</vs-th>
                <vs-th sort-key="grupo">Grupo</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :data="user"
                  :key="indextr"
                  v-for="(user, tr, indextr) in data"
                >
                  <vs-td :data="user.idUser">{{ user.idUser }}</vs-td>
                  <vs-td :data="user.userName">
                    <div v-lazy-container="{ selector: 'img' }">
                      <img
                        key="onlineImg"
                        v-bind:data-src="user.photo"
                        alt="product-img"
                        width="50"
                        height="50"
                        class="rounded-full shadow-md cursor-pointer block"
                      /></div
                  ></vs-td>
                  <vs-td :data="user.userName">{{ user.userName }}</vs-td>
                  <vs-td :data="user.email">{{ user.email }}</vs-td>
                  <vs-td :data="user.isActive">
                    <vs-chip color="success" v-if="user.isActive == 'S'">
                      {{ user.isActive }}
                    </vs-chip>
                    <vs-chip color="danger" v-if="user.isActive == 'N'">
                      {{ user.isActive }}
                    </vs-chip>
                  </vs-td>
                  <vs-td>
                    {{ momentJS.formatDateTimeForPTBR(user.lastLogin) }}
                  </vs-td>
                  <vs-td
                    v-if="user.userGroup == 'admin'"
                    :data="user.userGroup"
                  >
                    <vs-chip color="success">{{ user.userGroup }}</vs-chip>
                  </vs-td>
                  <vs-td v-else :data="user.userGroup">
                    <vs-chip color="warning">{{ user.userGroup }}</vs-chip>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Clientes">
          <div class="tab-text">
            <div class="tab-text">
              <vs-table
                v-model="selected"
                @selected="handleSelectedUserCustomer"
                pagination
                :max-items="100"
                search
                :data="customersUsers"
              >
                <template slot="thead">
                  <vs-th sort-key="idUser">#</vs-th>
                  <vs-th sort-key="photo">Foto</vs-th>
                  <vs-th sort-key="userName">Nome</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th sort-key="isActive">Ativo</vs-th>
                  <vs-th sort-key="grupo">Cliente</vs-th>
                  <vs-th sort-key="grupo">Última Interação</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="customersUsers"
                    :key="indextr"
                    v-for="(customersUsers, tr, indextr) in data"
                  >
                    <vs-td :data="customersUsers.idUserCustomer">{{
                      customersUsers.idUserCustomer
                    }}</vs-td>
                    <vs-td :data="customersUsers.userName">
                      <div v-lazy-container="{ selector: 'img' }">
                        <img
                          key="onlineImg"
                          v-bind:data-src="customersUsers.photo"
                          alt="product-img"
                          width="50"
                          height="50"
                          class="rounded-full shadow-md cursor-pointer block"
                        /></div
                    ></vs-td>
                    <vs-td :data="customersUsers.userName">{{
                      customersUsers.userName
                    }}</vs-td>
                    <vs-td :data="customersUsers.email">{{
                      customersUsers.email
                    }}</vs-td>
                    <vs-td :data="customersUsers.corporateName">{{
                      customersUsers.corporateName
                    }}</vs-td>
                    <vs-td>
                      {{
                        momentJS.formatDateTimeForPTBR(customersUsers.lastLogin)
                      }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { momentJS } from "@/helpers";
export default {
  components: {},
  data() {
    return {
      users: [],
      customersUsers: [],
      selected: [],
      momentJS: null,
    };
  },
  methods: {
    handleSelected(tr) {
      /*this.$vs.notify({ 
        title: `Selecionado ${tr.nome}`,
        text: `Email: ${tr.email}`
      });*/

      if (this.$store.state.user.idUser == tr.idUser) {
        this.$router.push(`/perfil`);
      } else {
        this.$router.push(`/usuarios/${tr.idUser}`);
      }
    },
    handleSelectedUserCustomer(tr) {
      this.$router.push(`/usuarios-clientes/${tr.idUserCustomer}`);
    },
    async loadUsers() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/user/getAllUsers`);
        this.users = response.data;
        //for (let user of response.data) {
        //this.users.push(user);
        //}
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    async loadCustomersUsers() {
      try {
        this.$vs.loading();
        const response = await axios.get(
          `${baseApiUrl}/userCustomers/getAllUsers`
        );
        this.customersUsers = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
  },
  sockets: {
    connect() {
      //console.log("socket connected");
    },
    loadUser: function (data) {
      let user = [];
      user.push(data);
      for (let item of user) {
        this.users.push(item);
      }
    },
  },
  async created() {
    this.momentJS = momentJS();
    await this.loadUsers();
    await this.loadCustomersUsers();
  },
};
</script>
